import http from '@/utils/http';
import { IDENTITY_KEY_NAME } from '@/constants';
import { getIdentity } from '@/utils/detectDevice';

const post = params => http.apiGet(`/addUserShare?uid=${getIdentity(IDENTITY_KEY_NAME.UID)}`, params);
const list = (id, sid, attempt) => http.apiGet(`/userShare/${id}/${sid}/${attempt}`);

export default {
  post,
  list,
};
